import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Iframe } from './style';
import { apiHost } from '../../api/config';

const FullscreenIframe = () => {
  const { search } = useLocation();
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(search.split('=').slice(1).join('='));
  }, [search]);

  return (
    <Iframe
      title="fullscreen"
      src={url}
      id="scorm_frame"
      allowFullscreen={`fullscreen ${apiHost}`}
      webkitallowfullscreen={`fullscreen ${apiHost}`}
      mozallowfullscreen={`fullscreen ${apiHost}`}
      msallowfullscreen={`fullscreen ${apiHost}`}
      oallowfullscreen={`fullscreen ${apiHost}`}
      allow={`fullscreen ${apiHost}`}
    />
  );
};

FullscreenIframe.propTypes = {};

export default FullscreenIframe;
